import { AlertResponse } from "@/api/AlertsService"
import { AlertCategory } from "@/types/alertConfigurations"

export function getAlarmFilterKey(alarm: AlertResponse | null): string | null {
   if (!alarm) return null

   const { alertConfiguration } = alarm
   if (alertConfiguration.category === AlertCategory.SYSTEM) {
      return alertConfiguration.systemCondition?.type ?? null
   }

   return alertConfiguration.id
}
